/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/funds'
export default icon
